"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlickStyleWrapper = void 0;
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const SlickArrow_1 = __importDefault(require("./SlickArrow"));
const epic_react_slick_1 = __importDefault(require("epic-react-slick"));
const common_1 = require("@epic-core/common");
const styled_components_1 = __importDefault(require("styled-components"));
exports.SlickStyleWrapper = styled_components_1.default.div `
    &.loc-ar {
        .slick-slider {
            & > div,
            .pagination {
                direction: ltr;
            }
        }
    }

    .slick-slider {
        .slick-control {
            position: relative;
            border: none;
            color: #333333;
            width: 3em;
            font-weight: bold;
            text-align: center;
            transition: all 0.2s;
            display: table;
            height: 100%;
            i {
                font-size: 1.6em;
                display: table-cell;
                vertical-align: middle;
            }
        }
        .slick-next {
            right: -3em;
        }
        .slick-prev {
            left: -3em;
            i {
                transform: rotate(-180deg);
            }
        }
        &.nav-top {
            div.slick-next {
                top: -43px;
                height: 37px;
                right: 0;
            }
            div.slick-prev {
                right: 50px;
                top: -43px;
                left: inherit;
                height: 37px;
            }
        }

        div.slick-next {
            top: -43px;
            height: 37px;
            right: 0;
        }
        div.slick-prev {
            right: 50px;
            top: -43px;
            left: inherit;
            height: 37px;
        }
    }
    div.slick-slider .slick-control {
        width: 2em;
    }
    div.slick-slider .slick-control {
        width: 2em;
        @media only screen and (max-width: 1399px) {
            div.slick-next {
                top: -43px;
                height: 37px;
                right: 0;
            }
            div.slick-prev {
                right: 50px;
                top: -43px;
                left: inherit;
                height: 37px;
            }
        }

        @media only screen and (max-width: 991px) {
            div.slick-next {
                right: -3px;
                .slick-control {
                    width: 2em;
                }
            }
            div.slick-prev {
                right: 22px;
                .slick-control {
                    width: 2em;
                }
            }
        }

        .slick-prev,
        .slick-next {
            position: absolute;
            display: block;
            height: 100%;
            top: 0;
            z-index: 99;
            &.slick-disabled {
                display: none !important;
            }
        }

        &:hover {
            .slick-control {
                &:hover {
                    color: #7ec0ee;
                }
            }
        }

        .pagination {
            text-align: center;
            li {
                display: inline-block;
                button {
                    display: inline-block;
                    width: 1em;
                    height: 1em;
                    border: 1px solid #333333;
                    margin: 1em;
                    border-radius: 50%;
                    background: transparent;
                    color: transparent;
                    @media only screen and (max-width: 511px) {
                        margin: 0.75em;
                    }
                }
                &.slick-active {
                    button {
                        background: #333333;
                    }
                }
            }
        }
    }
`;
/**
 * SlickWrapper.
 *
 * Rendered when the Route matches /watch
 */
class SlickWrapper extends react_1.default.PureComponent {
    slickGoTo(index) {
        this.slider.slickGoTo(index);
    }
    render() {
        const { options, children } = this.props;
        if (children.length < options.slidesToShow) {
            options.infinite = false;
        }
        if (children.length === 1) {
            return react_1.default.createElement("div", null, children);
        }
        const carouselItems = [];
        for (const child of children) {
            carouselItems.push(react_1.default.createElement("div", { key: child.key }, child));
        }
        return (react_1.default.createElement(exports.SlickStyleWrapper, { className: `slick-wrapper loc-${(0, common_1.getLocale)()}` },
            react_1.default.createElement(epic_react_slick_1.default, Object.assign({ ref: c => {
                    this.slider = c;
                }, className: this.props.className, nextArrow: react_1.default.createElement(SlickArrow_1.default, null), prevArrow: react_1.default.createElement(SlickArrow_1.default, null) }, options), carouselItems)));
    }
}
SlickWrapper.propTypes = {
    className: prop_types_1.default.string,
    options: prop_types_1.default.object,
    children: prop_types_1.default.node
};
exports.default = SlickWrapper;
//# sourceMappingURL=SlickWrapper.js.map